export default __webpack_public_path__ + "static/media/settings-icon.9f75e842.svg";